import { render, staticRenderFns } from "./AgenciamientoPemex.vue?vue&type=template&id=0d8b4390"
import script from "./AgenciamientoPemex.vue?vue&type=script&lang=js"
export * from "./AgenciamientoPemex.vue?vue&type=script&lang=js"
import style0 from "./AgenciamientoPemex.vue?vue&type=style&index=0&id=0d8b4390&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports